import { render, staticRenderFns } from "./ItemsPerPage.vue?vue&type=template&id=719214e0&"
import script from "./ItemsPerPage.vue?vue&type=script&lang=js&"
export * from "./ItemsPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports